import { render, staticRenderFns } from "./OrdersView.vue?vue&type=template&id=73bec636&scoped=true"
import script from "./OrdersView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrdersView.vue?vue&type=style&index=0&id=73bec636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bec636",
  null
  
)

export default component.exports